jQuery(document).on("page.ready", function () {
  $ = jQuery;

  if ($(".hero-slider").length) {
    // Home Hero Slider
    // ---
    var $heroSlider = $(".hero-slider .owl-carousel");
    $heroSlider
      .owlCarousel({
        autoplay: true,
        autoplayTimeout: 20000,
        autoplaySpeed: 400,
        autoplayHoverPause: true,
        loop: true,
        nav: false,
        items: 1,
        singleItem: true,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        dots: false,
        lazyLoad: true,
        onInitialized: checkIfVideo,
        responsive: {
          950: {
            //autoHeight: false
          },
        },
      })
      .on("changed.owl.carousel", function (event) {
        var index = event.item.index - 1,
          count = event.item.count,
          $bgs = $(".bgs >.container").children(),
          $numbers = $(".counter .current").children();

        if (event.item) {
          if (index > count) {
            index -= count;
          }
          if (index <= 0) {
            index += count;
          }
          //return index;
        }

        $heroSlider.trigger("stop.owl.autoplay"); // resets the autoplay when
        $heroSlider.trigger("play.owl.autoplay"); // user performs any actions
        $($numbers).removeClass("show");
        $($numbers[index - 1]).addClass("show");
        $($bgs).removeClass("active");
        $($bgs[index - 1]).addClass("active");

        $bgs.each(function (index, el) {
          var getVideo = $(el).children("video").get(0);
          if ($(el).hasClass("active") && $(el).hasClass("vid")) {
            var getVideo = $(el).children("video").get(0);
            $(getVideo).attr("loop", "true").attr("autoplay", "true").attr("playsinline", "playsinline");
            getVideo.play();
          } else if ($(el).hasClass("vid")) {
            var getVideo = $(el).children("video").get(0);
            $(getVideo).attr("loop", null).attr("autoplay", null).attr("playsinline", null);
            getVideo.load();
          }
        });

        if ($($bgs[index - 1]).hasClass("vid")) {
        } else {
        }
      });

    function checkIfVideo() {
      var $firstBg = $(".bgs >.container").children();
      if ($($firstBg[0]).hasClass("vid")) {
        var getVideo = $($firstBg[0]).children("video").get(0);
        $(getVideo).attr("loop", "true").attr("autoplay", "true").attr("playsinline", "playsinline");
        getVideo.play();
      }
    }

    // Navigation Arrows for Property Single Hero Slider
    $(".slider-controls button.next").on("click", function () {
      $heroSlider.trigger("next.owl.carousel");
    });
    $(".slider-controls button.prev").on("click", function () {
      $heroSlider.trigger("prev.owl.carousel");
    });
    // END Home slider
  }

  if ($("main.home").length) {
    var smcontroller = new ScrollMagic.Controller();

    // The Science Slider
    // ---
    var $scienceSlider = $(".sci-slides .owl-carousel");
    $scienceSlider
      .owlCarousel({
        autoplay: false,
        //loop: true,
        nav: false,
        items: 1,
        singleItem: true,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        dots: false,
        lazyLoad: true,
        autoHeight: true,
      })
      .on("changed.owl.carousel", function (event) {
        var $navItems = $(".sci-nav >.container").children();

        $($navItems).removeClass("active");
        $($navItems[event.item.index]).addClass("active");
      });

    $(".sci-nav >.container button").click(function (event) {
      $scienceSlider.trigger("to.owl.carousel", $(this).index());
      $(this).parent().children().removeClass("active");
      $(this).addClass("active");
    });
    // END The Science Slider

    // Products Slider
    // ---
    // $( window ).on( "load", function () {
    setTimeout(function () {
      var $productsNav = $(".products-nav .owl-carousel");
      $productsNav
        .owlCarousel({
          nav: false,
          rewind: true,
          center: true,
          rewindSpeed: 0,
          dots: false,
          loop: false,
          lazyLoad: true,
          autoWidth: true,
          onInitialized: fixStageHeight,
          responsive: {
            950: {
              //center: false,
              autoWidth: false,
              //autoHeight: false
            },
          },
        })
        .on("changed.owl.carousel", function (event) {
          $productsSlider.trigger("to.owl.carousel", event.item.index);
        });

      function fixStageHeight(event) {
        $(".products-nav .owl-carousel").each(function (index, el) {
          var $stage = $(this).children(".owl-stage-outer").children(".owl-stage"),
            $owlItems = $($stage).children(),
            totalWidth = 0;

          $($owlItems).each(function (index, el) {
            totalWidth += $(this).outerWidth(true);
          });

          $($stage).width(totalWidth + 1);
        });
      }

      $(document).on("click", ".products-nav .owl-carousel .owl-item", function () {
        $productsSlider.trigger("to.owl.carousel", $(this).index());
      });

      var $productsSlider = $(".products-slider .slider");
      $productsSlider
        .owlCarousel({
          nav: true,
          items: 1,
          singleItem: true,
          rewind: true,
          rewindSpeed: 0,
          dots: false,
          lazyLoad: true,
          autoHeight: true,
          navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="translate(-6 -5.379)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M107.824 18H7.5" transform="translate(0 12.95)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M30.95 54.4L7.5 30.95 30.95 7.5"/></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="rotate(180 50.912 24.51)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M100.324 0H0" transform="translate(0 23.45)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M23.45 46.9L0 23.45 23.45 0"/></g></svg>'],
          responsive: {
            950: {
              //autoHeight: false
            },
          },
        })
        .on("changed.owl.carousel", function (event) {
          var $numbers = $(".slider-count .top").children(),
            $video = $(".products-slider .video-bg video").get(0);

          $video.load();
          $video.play();

          $($numbers).removeClass("active");
          $($numbers[event.item.index]).addClass("active");

          $productsNav.trigger("to.owl.carousel", event.item.index);
        });
    }, 0);
  }
});
